// extracted by mini-css-extract-plugin
module.exports = {"filters":"_1wCyJ","filterList":"_3XjDl"};